import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('NotificationStore', {
  state: () => ({
    modal_notification: null,
    procedure_notification: null,
    side_notifications: [],
  }),
  actions: {
    postModalNotification (notification) {
      this.modal_notification = notification
    },
    postProcedureNotification (notification) {
      this.procedure_notification = notification
    },
    postSideNotification (notification) {
      this.side_notifications.push({ ...notification, timestamp: Date.now() })
    },
    deleteSideNotification (notification) {
      this.side_notifications = this.side_notifications.filter(({ timestamp }) => timestamp !== notification.timestamp)
    }
  }
})